import React, { useEffect, useState } from "react";
import { useOrganisations } from "../Auth/useOrganisations";
import { useTranslation } from "react-i18next";
import GifLoader from "../Components/loader";
import { getCreditSummaryPaginated } from "../Services/ClientApi";
import ClientDetailModal from "../Components/Caisse/ClientDetailModal";

const LIMIT = 20;

const CreditClientsList = () => {
  const { t } = useTranslation();
  const [, , usedOrganisations] = useOrganisations();

  const [clients, setClients] = useState([]);
  const [totalOutstanding, setTotalOutstanding] = useState(0);
  const [pagination, setPagination] = useState({ page: 1, pages: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [detailClient, setDetailClient] = useState(null);

  const load = async (p = 1) => {
    if (!usedOrganisations) return;
    setLoading(true);
    try {
      const res = await getCreditSummaryPaginated(usedOrganisations, p, LIMIT);
      if (res?.data?.success) {
        const { clients, totalOutstanding, pagination } = res.data.data;
        setClients(clients);
        setTotalOutstanding(totalOutstanding);
        setPagination(pagination);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load(page);
  }, [usedOrganisations, page]);

  const fmt = (n) => (typeof n === "number" ? n.toFixed(3) : "0.000");

  return (
    <div className="container-fluid">
      <GifLoader loading={loading} />

      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-body">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h4 className="box-title mb-0">
                    <i
                      className="fa fa-user-clock mr-2"
                      style={{ color: "#fd683e" }}
                    />
                    {t("Crédits clients encours")}
                  </h4>
                  {/* <small className="text-muted">
                    {pagination.total} client(s) avec solde impayé
                  </small> */}
                </div>
                <div
                  className="px-3 py-2 rounded"
                  style={{
                    background: "rgba(109,40,217,0.08)",
                    border: "1px solid rgba(109,40,217,0.2)",
                  }}
                >
                  <span className="text-muted" style={{ fontSize: "13px" }}>
                    Total encours
                  </span>
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: 700,
                      color: "#6d28d9",
                      lineHeight: 1.2,
                    }}
                  >
                    {fmt(totalOutstanding)} DT
                  </div>
                </div>
              </div>

              {/* Table */}
              <div className="table-responsive">
                <table className="table table-hover table-bordered mb-0">
                  <thead className="bg-light">
                    <tr>
                      <th style={{ width: "120px" }}>{t("Code")}</th>
                      <th>{t("Nom du client")}</th>
                      <th style={{ width: "160px" }}>{t("Téléphone")}</th>
                      <th style={{ width: "160px" }}>{t("Addresse")}</th>

                      <th className="text-right" style={{ width: "160px" }}>
                        {t("Crédit (DT)")}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {clients.length > 0 ? (
                      clients.map((c) => {
                        const cid = c._id || c.id;
                        return (
                        <tr key={cid}>
                          <td>
                            <span className="badge badge-pill badge-light font-weight-600">
                              {c.code}
                            </span>
                          </td>
                          <td>
                            <span
                              className="font-weight-600"
                              role="button"
                              style={{ color: "#6d28d9", cursor: "pointer" }}
                              onClick={() => setDetailClient(cid)}
                            >
                              {c.name}
                            </span>
                          </td>
                          <td>
                            {c.phone || <span className="text-muted">—</span>}
                          </td><td>
                            {c.address || <span className="text-muted">—</span>}
                          </td>
                          <td className="text-right">
                            <span
                              style={{
                                color: "#fd683e",
                                fontWeight: 700,
                                fontSize: "15px",
                              }}
                            >
                              {fmt(c.credit)}
                            </span>
                          </td>
                        </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center py-4 text-muted">
                          {loading
                            ? t("Chargement...")
                            : t("Aucun crédit impayé")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {/* Footer total */}
                  {clients.length > 0 && (
                    <tfoot>
                      <tr style={{ background: "#f8f9fa", fontWeight: 700 }}>
                        <td
                          colSpan="4"
                          className="text-right"
                          style={{ color: "#555" }}
                        >
                          {t("Total encours")}
                        </td>
                        <td
                          className="text-right"
                          style={{ color: "#6d28d9", fontSize: "15px" }}
                        >
                          {fmt(totalOutstanding)} DT
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>

              {/* Pagination */}
              {pagination.pages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span className="text-muted" style={{ fontSize: "13px" }}>
                    Page {pagination.page} / {pagination.pages} —{" "}
                    {pagination.total} clients
                  </span>
                  <ul className="pagination pagination-sm mb-0">
                    <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => setPage((p) => p - 1)}
                      >
                        <i className="fa fa-chevron-left" />
                      </button>
                    </li>
                    {Array.from({ length: pagination.pages }, (_, i) => i + 1)
                      .filter(
                        (p) =>
                          p === 1 ||
                          p === pagination.pages ||
                          Math.abs(p - page) <= 2,
                      )
                      .reduce((acc, p, idx, arr) => {
                        if (idx > 0 && p - arr[idx - 1] > 1) acc.push("...");
                        acc.push(p);
                        return acc;
                      }, [])
                      .map((p, idx) =>
                        p === "..." ? (
                          <li
                            key={`ellipsis-${idx}`}
                            className="page-item disabled"
                          >
                            <span className="page-link">…</span>
                          </li>
                        ) : (
                          <li
                            key={p}
                            className={`page-item ${page === p ? "active" : ""}`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setPage(p)}
                            >
                              {p}
                            </button>
                          </li>
                        ),
                      )}
                    <li
                      className={`page-item ${page === pagination.pages ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() => setPage((p) => p + 1)}
                      >
                        <i className="fa fa-chevron-right" />
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ClientDetailModal
        open={!!detailClient}
        onClose={() => setDetailClient(null)}
        clientId={detailClient}
        initialTab={2}
      />
    </div>
  );
};

export default CreditClientsList;
